import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import Transition from '@ember/routing/-private/transition';

import NewsletterOverviewReportsIndexController from 'cio/pods/broadcasts/newsletter/overview/reports/index/controller';
import NewsletterModel from 'cio/models/newsletter';
import EnvironmentService from 'cio/services/environment';
import MetricsService from 'cio/services/metrics';
import DS from 'ember-data';
import MessageSettingsService from 'cio/services/message-settings';

export default class NewsletterOverviewReportsIndexRoute extends Route {
  @service environment!: EnvironmentService;
  @service('metrics') metricsService!: MetricsService;
  @service messageSettings!: MessageSettingsService;
  @service store!: DS.Store;

  model() {
    let id = (this.paramsFor('broadcasts.newsletter') as any).newsletter_id;
    return this.store.findRecord('newsletter', id);
  }

  afterModel() {
    return this.messageSettings.loadMessagingLimit.perform();
  }

  setupController(
    controller: NewsletterOverviewReportsIndexController,
    model: NewsletterModel,
    transition: Transition,
  ) {
    super.setupController(controller, model, transition);

    controller.set('isMessagingLimitEnabled', this.messageSettings.isMessagingLimitEnabled);
    controller.fetchMetrics.perform();
  }

  resetController(controller: NewsletterOverviewReportsIndexController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.set('templateId', null);
    }
  }
}
